import { render, staticRenderFns } from "./summaryReport.vue?vue&type=template&id=38b96168&"
import script from "./summaryReport.vue?vue&type=script&lang=js&"
export * from "./summaryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports